import React from "react";
import GATSBY_COMPILED_MDX from "/home/runner/work/bartozzz.github.io/bartozzz.github.io/content/blog/2019-03-01-enterprise-scale-react-redux-project-architecture/index.md";
import "./blog-post.scss";
import {MDXProvider} from "@mdx-js/react";
import {mapSlugToImageName} from "../../gatsby/helpers/mapSlugToImageName.mjs";
import {Alert} from "../components/Alert";
import {Content} from "../components/Content";
import {Discussion} from "../components/Discussion";
import {Layout} from "../components/Layout";
import {Newsletter} from "../components/Newsletter";
import {PostAuthors} from "../components/PostExcerpt/PostAuthors";
import {PostTimeToRead} from "../components/PostExcerpt/PostTimeToRead";
import {SEO} from "../components/SEO";
import {TableOfContents} from "../components/TableOfContents";
import {jsx as _jsx} from "react/jsx-runtime";
import {jsxs as _jsxs} from "react/jsx-runtime";
function BlogPostTemplate(_ref) {
  let {data, pageContext, children} = _ref;
  const post = pageContext.data;
  const {frontmatter, tableOfContents} = post;
  const {slug, timeToRead} = post.fields;
  const {title, language, authors, datePublished, datePublishedMeta, dateUpdated, dateUpdatedMeta} = frontmatter;
  const siteUrl = data.site.siteMetadata.siteUrl;
  const thumbnailUrl = `${siteUrl}/thumbnails/${mapSlugToImageName(slug)}.png`;
  return _jsx(Layout, {
    children: _jsx(Content, {
      children: _jsxs("article", {
        className: "post",
        itemScope: true,
        itemType: "http://schema.org/Article",
        lang: language,
        children: [_jsx("meta", {
          itemProp: "image",
          content: thumbnailUrl
        }), _jsx("meta", {
          itemProp: "dateModified",
          content: dateUpdatedMeta
        }), _jsx("meta", {
          itemProp: "wordCount",
          content: `${timeToRead.words}`
        }), _jsxs("header", {
          className: "post__header",
          children: [_jsx("h1", {
            itemProp: "headline",
            children: title
          }), _jsxs("p", {
            className: "post__header--metadata",
            children: [_jsx(PostAuthors, {
              data: authors
            }), " on ", _jsx("time", {
              dateTime: datePublishedMeta,
              itemProp: "datePublished",
              title: `Last modified on ${dateUpdated}`,
              className: "post__header--date",
              children: datePublished
            }), " • ", _jsx(PostTimeToRead, {
              value: timeToRead.minutes
            })]
          })]
        }), _jsxs("div", {
          className: "post__wrapper",
          children: [tableOfContents.items ? _jsx("div", {
            className: "post__toc",
            children: _jsx(TableOfContents, {
              data: tableOfContents
            })
          }) : null, _jsxs("div", {
            className: "post__content",
            children: [_jsx("div", {
              itemProp: "articleBody",
              children: _jsx(MDXProvider, {
                components: {
                  Alert,
                  Newsletter
                },
                children: children
              })
            }), _jsx(Discussion, {
              lang: language
            })]
          })]
        })]
      })
    })
  });
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export function Head(_ref2) {
  let {data, pageContext} = _ref2;
  const post = pageContext.data;
  const slug = post.fields.slug;
  const {excerpt} = post;
  const {title, description} = post.frontmatter;
  const siteUrl = data.site.siteMetadata.siteUrl;
  const thumbnailUrl = `${siteUrl}/thumbnails/${mapSlugToImageName(slug)}.png`;
  return _jsx(SEO, {
    url: `${siteUrl}${slug}`,
    title: title,
    image: thumbnailUrl,
    description: description || excerpt,
    children: _jsx("html", {
      className: "smooth-scroll"
    })
  });
}
const query = "698804963";
